import { Component, Input, OnInit } from '@angular/core';
import { Account } from '../accounts.iface';

@Component({
  selector: 'app-acc-role',
  template: `
    @if (account.accessLevel === 'LEVEL_0') {
      <span>Super Admin</span>
    }
    @if (account.accessLevel === 'LEVEL_1' && account.parent) {
      <span>Vendor Admin</span>
    }
    @if (account.accessLevel === 'LEVEL_1' && !account.parent) {
      <span>Company</span>
    }
    @if (account.accessLevel === 'LEVEL_2') {
      <span>User</span>
    }
  `,
  styles: [],
  standalone: false,
})
export class RoleComponent implements OnInit {
  @Input() account: Account;
  constructor() {}
  ngOnInit() {}
}
